export const REDUCER_NAME = 'employeeKpi';

export interface IKpiTemplate {
  id: string; vendorId: string; name: string; description?: string;
  category: 'attendance'|'sales'|'task'|'custom'; unit: string;
  default_target: number; weight: number; is_active: number; created_at: string;
}

export interface IKpiAssignment {
  templateId: string; name: string; category: string; unit: string;
  weight: number; target_value: number; assignmentId?: string;
}

export interface IKpiResult {
  templateId: string; name: string; category: string; unit: string;
  weight: number; target: number; actual: number | null;
  achievement: number; contribution: number;
}

export interface IEmployeePerformance {
  employeeId: string;
  period: { start: string; end: string; type: string };
  score: number; grade: 'A'|'B'|'C'|'D';
  kpis: IKpiResult[];
  attendance: { summary: any[]; rate: number | null };
}

export interface ITeamMember {
  employeeId: string; name: string; email: string; profilePicture?: string;
  mobile?: string; score: number; grade: 'A'|'B'|'C'|'D'; kpiCount: number;
}

export interface IAttendanceRecord {
  date: string; clock_in?: string; clock_out?: string;
  status: 'present'|'absent'|'late'|'half_day'; notes?: string;
}

export interface IEmployeeKpiState {
  templates: IKpiTemplate[];
  totalWeight: number;
  assignments: IKpiAssignment[];
  performance: IEmployeePerformance | null;
  teamPerformance: ITeamMember[];
  attendance: IAttendanceRecord[];
  attendanceSummary: any[];
  isLoading: boolean;
  errorMessage: string | null;
}
